import React, { useContext, useEffect } from 'react';

import Loading from 'components/Loading';
import VisualisationCacheContext from 'contexts/VisualisationCacheContext';

// Loads every dashboard gadget (they're loaded on demand, not at startup) and
// shows a spinner until they're cached. For lookups that scan all gadgets,
// e.g. where a report or board is used as a popup: mount it only when the
// user asks for one.
const AllDashboardGadgetsGate = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { requestAllDashboardGadgets, allGadgetsLoaded } = useContext(
    VisualisationCacheContext,
  );

  useEffect(() => {
    requestAllDashboardGadgets();
  }, [requestAllDashboardGadgets]);

  if (!allGadgetsLoaded) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default AllDashboardGadgetsGate;
